module.exports = __webpack_public_path__ + "static/nordevcon19-d73d71852a1cd3b4a4286d5d9fe91ddf.jpeg";